import { Navigate, type RouteObject } from 'react-router';
import { INTEGRATION_TABS, integrationTabPath } from './integrations.paths';
import { IntegrationsPage } from './pages/IntegrationsPage';

/** Every route renders the same page, so React keeps it mounted while the install, edit and map sheets open and close. */
export const INTEGRATION_ROUTES: RouteObject[] = [
  { path: 'integrations', element: <Navigate to={integrationTabPath(INTEGRATION_TABS[0])} replace /> },
  { path: 'integrations/catalogue', element: <IntegrationsPage tab="catalogue" /> },
  { path: 'integrations/installed', element: <IntegrationsPage tab="installed" /> },
  { path: 'integrations/installed/new', element: <IntegrationsPage tab="installed" sheet="install" /> },
  { path: 'integrations/installed/:id', element: <IntegrationsPage tab="installed" sheet="edit" /> },
  { path: 'integrations/device-mappings', element: <IntegrationsPage tab="device-mappings" /> },
  { path: 'integrations/device-mappings/new', element: <IntegrationsPage tab="device-mappings" sheet="map" /> },
];
